import { apiClient } from './client'

// 权限项
export interface PermissionItem {
	key: string
	label: string
}

// 权限分组
export interface PermissionGroup {
	name: string
	permissions: PermissionItem[]
}

// 用户权限响应
export interface UserPermissionsResponse {
	is_super_admin: boolean
	permissions: string[]
}

// 部门权限响应
export interface DepartmentPermissionsResponse {
	department_id: number
	permissions: string[]
}

// 设置部门权限请求
export interface SetDepartmentPermissionsRequest {
	permissions: string[]
}

// 权限 API
export const permissionsApi = {
	// 获取所有权限分组
	getGroups: async (): Promise<PermissionGroup[]> => {
		const response = await apiClient.get<PermissionGroup[]>('/permissions')
		return response.data
	},

	// 获取当前用户权限
	getUserPermissions: async (): Promise<UserPermissionsResponse> => {
		const response = await apiClient.get<UserPermissionsResponse>('/users/me/permissions')
		return response.data
	},

	// 获取部门权限
	getDepartmentPermissions: async (departmentId: number): Promise<DepartmentPermissionsResponse> => {
		const response = await apiClient.get<DepartmentPermissionsResponse>(`/departments/${departmentId}/permissions`)
		return response.data
	},

	// 设置部门权限
	setDepartmentPermissions: async (departmentId: number, data: SetDepartmentPermissionsRequest): Promise<void> => {
		await apiClient.put(`/departments/${departmentId}/permissions`, data)
	},
}
